import {Chip, Collapse, Divider, FormLabel} from "@mui/material";
import {MdsKeyboardArrowDown, MdsKeyboardArrowUp} from "@sinch/icons";
import {mergeDeepRight} from "ramda";
import React, {FC, useState} from "react";
import {useTranslation} from "react-i18next";
import {MdsIcon} from "@sinch/components";
import {
  MinimumHoursOptions,
  MinimumHoursOptionsValue,
} from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/IntervalSelect/IntervalPopover/MinimumHoursOptions";
import {
  PriorityInput
} from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/IntervalSelect/IntervalPopover/PriorityInput";
import {
  type AnyUnitName,
  RoundingInput,
} from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/IntervalSelect/IntervalPopover/RoundingInput";

interface IntervalAdvancedOptionsProps {
  onChange: (val: IntervalAdvancedOptionsValue) => void;
  value: IntervalAdvancedOptionsValue;
  hasMinHours: boolean;
  unitName: AnyUnitName;
}

export type IntervalAdvancedOptionsValue = MinimumHoursOptionsValue & {
  unit: { priority: number | null };
  roundingId: string | null;
};

export const IntervalAdvancedOptions: FC<IntervalAdvancedOptionsProps> = ({ value, onChange, hasMinHours, unitName }) => {
  const { t } = useTranslation();
  const [openAdvanced, setOpenAdvanced] = useState(false);
  const modifyVal = mergeDeepRight(value ?? {});

  return (
    <>
      <Divider sx={{ my: 2 }}>
        <Chip
          deleteIcon={<MdsIcon icon={openAdvanced ? MdsKeyboardArrowUp : MdsKeyboardArrowDown} />}
          label={t("RateBuilder.advancedOptions")}
          onClick={() => {
            setOpenAdvanced((prev) => !prev);
          }}
          onDelete={() => {
            setOpenAdvanced((prev) => !prev);
          }}
          size="small"
        />
      </Divider>
      <Collapse in={openAdvanced} sx={{ mb: 2 }}>
        <MinimumHoursOptions
          disabled={!hasMinHours}
          onChange={(val) => onChange(modifyVal({ minimum: { ...val.minimum } }))}
          value={value}
        />
        <FormLabel sx={{ display: "flex", alignItems: "left", mt: 1 }}>{t("RateBuilder.priorities")}</FormLabel>
        <PriorityInput
          onChange={(val) => onChange(modifyVal({ unit: { priority: val } }))}
          value={value?.unit.priority}
        />
        <RoundingInput onChange={(val) => onChange(modifyVal({ roundingId: val }))} unitName={unitName} value={value?.roundingId ?? null} />
      </Collapse>
    </>
  );
};
